import { ButtonProps, Theme } from '@mui/material';
import { PhotoIcon, TrashIcon } from '@synergy/theme';
import { makeStyles } from '@mui/styles';

import { PoolIconButton } from '../icon-button/pool-icon-button';

const useStyles = makeStyles((theme: Theme) => ({
    button: {
        width: 40,
        height: 40,
        backgroundColor: theme.palette.primary.main,
        border: 'none',
        boxShadow: 'none',

        '& svg': {
            fontSize: 20,
        },

        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },

        '&:disabled': {
            backgroundColor: theme.palette.grey[500],
        },
    },
}));

interface PoolAvatarIconButtonProps extends ButtonProps {
    hasSrc: boolean;
    /** What the button does, in words — passed in, the component has no translations. */
    removeLabel?: string;
    addLabel?: string;
}

export const PoolAvatarIconButton = (props: PoolAvatarIconButtonProps) => {
    const { hasSrc, removeLabel = 'Logo entfernen', addLabel = 'Logo hinzufügen', ...buttonProps } = props;

    const classes = useStyles();

    return (
        <PoolIconButton
            {...buttonProps}
            aria-label={hasSrc ? removeLabel : addLabel}
            title={hasSrc ? removeLabel : addLabel}
            className={`${props.className || ''} ${classes.button}`}
        >
            {hasSrc ? <TrashIcon htmlColor="#fff" /> : <PhotoIcon />}
        </PoolIconButton>
    );
};
